export const messages = {
  en: {
    shopAudit: {
      title: 'Shop Audit',
      queryConditions: 'Query Conditions',
      shopName: 'Shop Name',
      returnContact: 'Return Contact',
      returnPhone: 'Return Phone',
      auditStatus: 'Audit Status',
      query: 'Query',
      auditList: 'Audit List',
      auditId: 'Audit ID',
      name: 'Name',
      deliveryAddress: 'Delivery Address',
      operation: 'Operation',
      view: 'View',
      auditInfo: 'Audit Information',
      back: 'Back',
      shopDesc: 'Shop Description',
      shopType: 'Shop Type',
      openType: 'Open Type',
      shopLogo: 'Shop Logo',
      areaCode: 'Area Code',
      returnAddress: 'Return Address',
      applyReason: 'Apply Reason',
      rejectReason: 'Reject Reason',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      merchant: 'Merchant',
      service: 'Service',
      merchantAndService: 'Merchant and Service',
      logo: 'Logo:',
      sendAddress: 'Shipping Address:',
      areaName: 'Area Code:',
      returnPerson: 'Return Contact:',
      returnLink: 'Return Phone:',
      applyOpinion: 'Application Reason:',
      auditOpinion: 'Audit Opinion:',
      auditResult: 'Audit Result',
      selectAuditStatus: 'Please select audit status',
      agree: 'Agree',
      reject: 'Reject',
      auditOpinionPlaceholder: 'Required, please fill in the audit opinion',
      submit: 'Submit',
      cancel: 'Cancel',
      allStatus: 'All Status',
      pendingAudit: 'Pending Audit',
      auditPassed: 'Audit Passed',
      auditFailed: 'Audit Failed'
    }
  },
  zh: {
    shopAudit: {
      title: '店铺审核',
      queryConditions: '查询条件',
      shopName: '店铺名称',
      returnContact: '退货联系人',
      returnPhone: '退货联系电话',
      auditStatus: '审核状态',
      query: '查询',
      auditList: '店铺审核',
      auditId: '审核ID',
      name: '名称',
      deliveryAddress: '发货地址',
      operation: '操作',
      view: '查看',
      auditInfo: '店铺审核信息',
      back: '返回',
      shopDesc: '店铺描述',
      shopType: '店铺类型',
      openType: '开店类型',
      shopLogo: '店铺logo',
      areaCode: '地域编码',
      returnAddress: '退货地址',
      applyReason: '申请原因',
      rejectReason: '不通过意见',
      pending: '待审核',
      approved: '审核通过',
      rejected: '审核不通过',
      merchant: '商家',
      service: '服务',
      merchantAndService: '商家和服务',
      logo: 'logo',
      sendAddress: '发货地址',
      areaName: '地域编码',
      returnPerson: '退货联系人',
      returnLink: '退货电话',
      applyOpinion: '申请原因',
      auditOpinion: '审核意见',
      auditResult: '审核结果',
      selectAuditStatus: '请选择审核状态',
      agree: '同意',
      reject: '拒绝',
      auditOpinionPlaceholder: '必填，请填写审核意见',
      submit: '提交',
      cancel: '取消',
      allStatus: '全部状态',
      pendingAudit: '待审核',
      auditPassed: '审核通过',
      auditFailed: '审核不通过'
    }
  }
}